import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
var portalCreateProductExperienceId = 'service-management.help-center.portal-request-create.form';
export var portalCreateProductExperience = new UFOExperience(portalCreateProductExperienceId, {
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageSegmentLoad
});